"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYFV2Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var KYFV2Factory = /** @class */ (function (_super) {
    __extends(KYFV2Factory, _super);
    function KYFV2Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    KYFV2Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    KYFV2Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    KYFV2Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    KYFV2Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    KYFV2Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return KYFV2Factory;
}(contracts_1.ContractFactory));
exports.KYFV2Factory = KYFV2Factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_hardCap",
                type: "uint256",
            },
        ],
        name: "HardCapSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "Removed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_verified",
                type: "address",
            },
        ],
        name: "Verified",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_verifier",
                type: "address",
            },
        ],
        name: "VerifierSet",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "checkVerified",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "count",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "hardCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isVerified",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "remove",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "_users",
                type: "address[]",
            },
        ],
        name: "removeMultiple",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_hardCap",
                type: "uint256",
            },
        ],
        name: "setHardCap",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_verifier",
                type: "address",
            },
        ],
        name: "setVerifier",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "verifier",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "_v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "_r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_s",
                type: "bytes32",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=KYFV2Factory.js.map